module.exports = __webpack_public_path__ + "img/br3cj.7c769b2f.png";